"use strict";

require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FileUpload = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _reactHookForm = require("react-hook-form");
var _InputText = require("../InputText");
var _FileUploadLabelDefault = require("./FileUploadLabels/FileUploadLabelDefault");
var _FileUploadLabelButtonStyle = require("./FileUploadLabels/FileUploadLabelButtonStyle");
var _FileUploadListDefault = require("./FileUploadLists/FileUploadListDefault");
var _FileUploadListReveal = require("./FileUploadLists/FileUploadListReveal");
var _FileValidation = require("./FileValidation");
var _propTypes = require("../../../../propTypes");
require("./FileUpload.scss");
const _excluded = ["fieldFormContext", "validFiles", "labelStyle", "listStyle", "allowMultiple", "customChangeHandler", "labelIcon", "customFileUploadLabel", "readOnly", "defaultSelectedFiles", "customRemoveHandler"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const FileUpload = _ref => {
  let {
      fieldFormContext,
      validFiles = {
        extensions: ['.pdf'],
        fileTypes: 'documents',
        supportsLabel: 'pdfs',
        maxFileCount: 8,
        maxFileSize: 10485760 // 10 MB
      },

      labelStyle = 'default',
      listStyle = 'default',
      allowMultiple = true,
      customChangeHandler,
      labelIcon,
      customFileUploadLabel,
      readOnly,
      defaultSelectedFiles = [],
      customRemoveHandler
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const hookFormContext = (0, _reactHookForm.useFormContext)();
  const formContext = fieldFormContext || hookFormContext;
  const {
    clearErrors
  } = formContext;
  const [selectedFiles, setSelectedFiles] = (0, _react.useState)(defaultSelectedFiles);
  const fileInputField = (0, _react.useRef)(null);
  const {
    validation
  } = rest;
  validation.validate = (fileList, file) => (0, _FileValidation.FilesValidator)({
    fileList,
    file,
    clearErrors,
    fieldName: rest.name,
    validFiles,
    requiredMessage: validation.required
  });
  const HandleFileSelection = event => {
    const inputField = event.target;
    const newFiles = [...inputField.files];
    const updatedFiles = [...selectedFiles, ...newFiles];
    setSelectedFiles(updatedFiles);

    // File inputs are different from normal inputs due to their file select dialog.
    // Need to manually blur the input to trigger the validation.
    setTimeout(() => {
      fileInputField.current.getElementsByTagName('input')[0].blur();
    }, 50);
    if (customChangeHandler) {
      customChangeHandler(event);
    }
  };
  const HandleFileRemove = fileToRemove => {
    const adjFileList = new DataTransfer();
    [...selectedFiles].forEach(file => {
      if (file.name !== fileToRemove.name) {
        adjFileList.items.add(file);
      }
    });
    setSelectedFiles(adjFileList.files);
    if (customRemoveHandler) {
      customRemoveHandler(fileToRemove);
    }
  };
  const cssClassName = (0, _react.useMemo)(() => {
    return "\n      fileUploadField \n      labelStyle_".concat(labelStyle, " \n      listStyle_").concat(listStyle, " \n      ").concat(readOnly ? 'isReadOnly' : '', "\n      ").concat(rest.customCssClass || '', "\n    ");
  }, [labelStyle, listStyle, rest.customCssClass, readOnly]);

  // Handle drag events
  const HandleDragOver = event => {
    event.preventDefault(); // Necessary to allow dropping
  };

  const HandleDrop = event => {
    event.preventDefault();
    const {
      files
    } = event.dataTransfer;
    const newFiles = [...files];
    const updatedFiles = [...selectedFiles, ...newFiles];
    formContext.setValue(rest.name, updatedFiles);
    setSelectedFiles(updatedFiles);

    // If there's a custom handler for file change
    if (customChangeHandler) {
      customChangeHandler(event);
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: fileInputField,
    className: cssClassName,
    title: "".concat(rest.placeholder || rest.label, " ").concat(allowMultiple ? 'Hold Ctrl on PCs, or Command key on macs, whilst using the file picker to select multiple files.' : ''),
    onDragOver: HandleDragOver,
    onDrop: HandleDrop
  }, /*#__PURE__*/_react.default.createElement(_InputText.InputText, _extends({
    fieldFormContext: formContext,
    accept: validFiles.extensions.join(','),
    multiple: allowMultiple
  }, rest, {
    defaultValue: "",
    label: labelStyle === 'button' ? /*#__PURE__*/_react.default.createElement(_FileUploadLabelButtonStyle.FileUploadLabelButtonStyle, _extends({}, rest.labelStyleButtonProps, {
      onClick: () => fileInputField.current.querySelector('input').click()
    })) : /*#__PURE__*/_react.default.createElement(_FileUploadLabelDefault.FileUploadLabelDefault, {
      validFiles: validFiles,
      label: rest.label
    }),
    inputType: "file",
    files: selectedFiles,
    customChangeHandler: e => HandleFileSelection(e)
  })), listStyle === 'reveal' ? /*#__PURE__*/_react.default.createElement(_FileUploadListReveal.FileUploadListReveal, {
    onFileRemove: HandleFileRemove,
    fileList: selectedFiles,
    validFiles: validFiles
  }) : /*#__PURE__*/_react.default.createElement(_FileUploadListDefault.FileUploadListDefault, {
    onFileRemove: HandleFileRemove,
    fileList: selectedFiles,
    validFiles: validFiles
  }));
};
exports.FileUpload = FileUpload;
FileUpload.propTypes = _propTypes.FileUploadPropTypes;
FileUpload.defaultProps = _propTypes.FormFieldDefaultProps;
var _default = exports.default = FileUpload;